import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from '../../core/interfaces/cell-renderer.interface';
import { StatusEnum } from '@albatrosdeveloper/ave-models-package/lib/enums/status.enum';

/**
 * Status Cell Renderer Component
 *
 * Muestra el nombre del estado en español basado en el statusId.
 * Utiliza la función getStatusNameSpanish para mapear el número a texto.
 *
 * Uso en ColDef:
 * {
 *   field: 'statusId',
 *   headerName: 'Estado',
 *   minWidth: 200,
 *   cellRenderer: StatusCellRendererComponent
 * }
 */
@Component({
  selector: 'app-status-cell-renderer',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="text-content">
      <span class="font-descrip">
        {{ statusName }}
      </span>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
        width: 100%;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderStatusCellRendererComponent
  implements CellRenderer<any, any>
{
  @Input() params!: CellRendererParams<any, any>;

  getStatusNameSpanish(status: number): string {
    return status === StatusEnum.INACTIVE || status === StatusEnum.ORDER_REJECTED ? 'Si' : 'No';
  }

  /**
   * Retorna el nombre del estado según el valor numérico
   */
  get statusName(): string {
    const value = this.params?.data?.statusId ?? this.params?.value;
    return this.getStatusNameSpanish(value);
  }
}
